// extracted by mini-css-extract-plugin
export var externalLink = "_6i-0";
export var internalLinkLabel = "_6i-1";